import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from "@angular/core";
import { SharedService } from '../../shared';
import { CamProductList_EN } from "../../dateneingabe-frageboge/productList-en";
import { LANGUAGE_ENUM, getCategoryLabel } from "../../dateneingabe-frageboge/questionnaire.model";
import { ITerritories, Territories } from './territory.data';
import { cloneDeep } from "lodash";


@Component({
    selector: 'app-prescription-popup',
    templateUrl: "./prescription-popup.component.html",
    styleUrls: ["./prescription-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class PrescriptionPopupComponent implements OnInit {
    @Input() LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    @Input() camObj: any;

    LANGUAGE_ENUM = LANGUAGE_ENUM;

    selectedTerritory: string = "Canada";
    territoriesDDL: ITerritories[] = cloneDeep(Territories);

    @Output() onBtnCLick: EventEmitter<any> = new EventEmitter();



    constructor(private sharedService: SharedService) {

    }

    ngOnInit(): void {
    }

    get PrductCategory() {
        return this.camObj.category.value;
    }
    get CamCategory() {
        let category = this.PrductCategory;
        var label = getCategoryLabel(category, LANGUAGE_ENUM.EN);
        return label;
    }

    get CamCannabinoid() {
        if (this.CamProductDetail) {
            return this.CamProductDetail.category;
        }
        return "";
    }

    get CamProductDetail() {
        let freeText = this.camObj.product.freeText;
        if (freeText) {
            let value = "";
            if (this.camObj.product['thc'] && this.camObj.product['cbd']) {
                value = `${this.camObj.product['thc']}/${this.camObj.product['cbd']}`;
            } else {
                const match = freeText.match(/\(([^)]+)\)/);
                value = match ? match[1] || "" : null;
            }
            return { label: freeText, thc_cbd: value || "", category: this.CamCategory, partner: "" };
        }
        let product = this.camObj.product.value;
        if (product) {
            var label = this.CamCategory;
            let data = CamProductList_EN.find(a => a.label == label)?.options || [];
            let productItem = data.find(a => a.label == product);
            return productItem;
        }
        return null;
    }

    get CamTHC_CBD() {
        if (this.CamProductDetail) {
            var value = this.CamProductDetail.thc_cbd || "";
            var thc_cbd = value.split("/");
            return { THC: thc_cbd.length > 0 ? thc_cbd[0] || 0 : 0, CBD: thc_cbd.length > 1 ? thc_cbd[1] || 0 : 0 };
        }
        return { THC: 0, CBD: 0 };
    }

    get CamTherapieName() {
        if (this.CamProductDetail && this.CamProductDetail.partner == "Aurora") {
            let product = this.camObj.product.value;
            return product;
        }
        return this.PrductCategory;
    }

    get CamTherapieIcon() {
        switch (this.CamCategory) {
            case 'Flowers':
                return "/pep/images/icons/Flower - Green.svg";
            case 'Extracts':
                return "/pep/images/icons/Exract - Green.svg";
            case 'Dronabinol':
                return "/pep/images/icons/Dronabinol - Green.svg";
            case 'Sativex':
                return "/pep/images/icons/Spray - Sativex - Green.svg";
            case 'Other':
                return "/pep/images/icons/Andere - Green.svg";
            default:
                return "/pep/images/icons/Kapsel - Green.svg";
        }
    }

    get TerritoryDetail() {
        let data = this.territoriesDDL.find(a => a.Name == this.selectedTerritory)?.Data || [];
        let detail = data.find(a => a.Format == this.CamCategory && a.Cannabinoid == this.CamCannabinoid);
        return detail;
    }

    get CamProducts() {
        if (this.TerritoryDetail) {
            return this.TerritoryDetail.Products;
        }
        return [];
    }
}
